/**
 * @generated SignedSource<<745579e9b2bfcc37b1b573efa2fdccf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountDetailConnectUpdateInput = {
  type?: string | null;
  meetSubdomain?: string | null;
  businessNumber?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};
export type accountBillingConnectUpdateMutation$variables = {
  id: string;
  input: AccountDetailConnectUpdateInput;
};
export type accountBillingConnectUpdateMutation$data = {
  readonly updateAccountDetailConnect: {
    readonly accountDetailConnect: {
      readonly " $fragmentSpreads": FragmentRefs<"accountConnectDetailInlineFragment">;
    };
  };
};
export type accountBillingConnectUpdateMutation = {
  variables: accountBillingConnectUpdateMutation$variables;
  response: accountBillingConnectUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetSubdomain",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessNumber",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountBillingConnectUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDetailConnectPayload",
        "kind": "LinkedField",
        "name": "updateAccountDetailConnect",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDetailConnect",
            "kind": "LinkedField",
            "name": "accountDetailConnect",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "accountConnectDetailInlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountBillingConnectUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDetailConnectPayload",
        "kind": "LinkedField",
        "name": "updateAccountDetailConnect",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDetailConnect",
            "kind": "LinkedField",
            "name": "accountDetailConnect",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a001a56e7ec9b301154379683be39a46",
    "id": null,
    "metadata": {},
    "name": "accountBillingConnectUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation accountBillingConnectUpdateMutation(\n  $id: ID!\n  $input: AccountDetailConnectUpdateInput!\n) {\n  updateAccountDetailConnect(id: $id, input: $input) {\n    accountDetailConnect {\n      ...accountConnectDetailInlineFragment\n      id\n    }\n  }\n}\n\nfragment accountConnectDetailInlineFragment on AccountDetailConnect {\n  type\n  meetSubdomain\n  businessNumber\n  latitude\n  longitude\n}\n"
  }
};
})();

(node as any).hash = "788bae89fd42ccf3880365316541a891";

export default node;
